import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgClock = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M15.146 15.854C15.244 15.951 15.372 16 15.5 16C15.628 16 15.756 15.951 15.854 15.854C16.049 15.659 16.049 15.342 15.854 15.147L12.5 11.793V5.5C12.5 5.224 12.276 5 12 5C11.724 5 11.5 5.224 11.5 5.5V12.207L15.146 15.854Z' />
    <path d='M12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22ZM12 3C7.038 3 3 7.038 3 12C3 16.962 7.038 21 12 21C16.962 21 21 16.962 21 12C21 7.038 16.962 3 12 3Z' />
  </svg>
);
export default SvgClock;
